import { BRAND } from "../lib/site-data";

/**
 * Renders the DN Flooring logo at a given pixel height.
 * Width auto-scales to preserve the source image's aspect ratio.
 */
export const LogoMark = ({ height = 40, className = "" }) => (
  <img
    src={BRAND.logoUrl}
    alt="DN Flooring"
    className={className}
    style={{ height, width: "auto" }}
  />
);
